import React, { useRef, useCallback, useMemo, useEffect } from 'react';

import { useSelector, useDispatch } from 'react-redux';
import { format, setHours, setMinutes, setSeconds, subDays, parseISO } from 'date-fns';
import { find } from 'lodash'

import { Visibility } from '@material-ui/icons';

import { UnidataTable, Modal } from '~/components';
import DetalhesAuditoria from './DetalhesAuditoria';


import {
    recordFiltering,
} from '~/store/modules/auditoria/actions';


function Auditoria() {

    const data = useSelector((state) => state.auditoria);

    const modalRef = useRef(null);

    const optionsAcao = useMemo(() => [
        { label: 'I', value: 'Inclusão' },
        { label: 'A', value: 'Alteração' },
        { label: 'E', value: 'Exclusão' },
        { label: 'C', value: 'Acesso' },
        { label: 'R', value: 'Relatório' },
        { label: 'O', value: 'Operação' },
    ], []);

    const handleFormatAcao = useCallback((value) => {
        let objectAcao = find(optionsAcao, (item) => item.label == value)
        return objectAcao.value
    }, [optionsAcao])

    const header = useMemo(() => [
        { id: 'usua_login', label: 'Usuário Acesso', filter: { type: 'text' } },
        { id: 'usua_nome', label: 'Usuário Nome', filter: { type: 'text' } },
        {
            id: 'ausi_datahora',
            label: 'Data registro',
            formatted: (value) => format(parseISO(value), 'dd/MM/yyyy HH:mm')
        },
        { id: 'ausi_resumo_processo', label: 'Resumo', filter: { type: 'text' } },
        {
            id: 'ausi_acao',
            label: 'Ação',
            filter: {
                type: 'select',
                options: optionsAcao
            },
            formatted: (value) => handleFormatAcao(value)
        },
        { id: 'ausi_chave', label: 'Chave', filter: { type: 'text' } },
        // { id: 'ausi_acao_string', label: 'Ação Descrição', filter: { type: 'text' } },
        // { id: 'usua_perf_codigo', label: 'Usuário Perfil Codigo', filter: { type: 'text' } },
        // { id: 'usua_perf_tipo', label: 'Usuário Perfil Tipo', filter: { type: 'text' } },
        { id: 'perf_descricao', label: 'Usuário Perfil Descrição', filter: { type: 'text' } },
        { id: 'usua_orga_codigo', label: 'Órgão usuário', filter: { type: 'text' } },
        { id: 'usua_orga_nome', label: 'Órgão Nome Usuário', filter: { type: 'text' } },
        //{ id: 'usua_poco_codigo', label: 'Posto Codigo Usuário', filter: { type: 'text' } },
        { id: 'usua_poco_descricao', label: 'Posto Nome Usuário', filter: { type: 'text' } },
        { id: 'ausi_modulo', label: 'DataCAll', filter: { type: 'text' } },
        { id: 'ausi_modulo_descricao', label: 'Descrição do Modulo', filter: { type: 'text' } },
        { id: 'ausi_orgao', label: 'Órgão Código', filter: { type: 'text' } },
        { id: 'orga_nome', label: 'Órgão Nome', filter: { type: 'text' } },
        { id: 'ausi_unidade', label: 'Unidade Código', filter: { type: 'text' } },
        { id: 'unid_nome', label: 'Unidade Nome', filter: { type: 'text' } },
        { id: 'ausi_placa', label: 'Placa Base', filter: { type: 'text' } },
        { id: 'ausi_placa_aux', label: 'Placa Mercosul', filter: { type: 'text' } },
        //{ id: 'ausi_poco_codigo', label: 'Posto Código', filter: { type: 'text' } },
        { id: 'poco_descricao', label: 'Posto Nome', filter: { type: 'text' } },
        
    ], []);


    const datahorainicial = useMemo(
        () =>
            format(
                setSeconds(setMinutes(setHours(subDays(new Date(), 7), 0), 0), 0),
                'dd/MM/yyyy HH:mm:ss'
            ),
        []
    );

    const datahorafinal = useMemo(
        () =>
            format(
                setSeconds(setMinutes(setHours(new Date(), 23), 59), 59),
                'dd/MM/yyyy HH:mm:ss'
            ),
        []
    );


    const filter = useMemo(() => [
        {
            id: 'data_cadastro_ini',
            label: ' Inicial',
            type: 'initialdatetime',
            defaultValue: datahorainicial
        },
        {
            id: 'data_cadastro_fim',
            label: 'Final',
            type: 'finaldatetime',
            defaultValue: datahorafinal
        }
    ], [datahorainicial, datahorafinal]);

    const buttons = useMemo(() => [
        {
            title: 'Detalhes',
            icon: <Visibility />,
            action: (value) => modalRef.current.handleOpenModal({ data: { ...value } })
        }
    ], []);

    const modalButton = useMemo(() => [{
        title: 'Fechar',
        label: 'Fechar',
        color: 'secondary',
        callback: () => modalRef.current.handleCloseModal()
    }], [modalRef])



    return (
        <>
            <UnidataTable
                fixed                
                update={false}
                create={false}
                delete={false}
                header={header}
                redux={data}
                custom={filter}
                actions={buttons}
                key={['usua_login']}
                detach="usua_nome"
                read={recordFiltering}
            />
            <Modal
                ref={modalRef}
                component={DetalhesAuditoria}
                title={'Detalhes Auditoria'}
                maxWidth="lg"
                actions={modalButton}
            />
        </>
    );
}

export default Auditoria;
